import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AuthService,
  DataService,
  ToasterService,
} from '../../../../shared/services';
import { Router } from '@angular/router';
import { GridOptions } from 'ag-grid-community';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActionStatusModel } from '../../../../shared/models';
import { ConfirmModalComponent } from '../../../../shared/modals';
import { GridComponent } from '../../../../shared';
import { FastlcActionStatusesEditComponent } from './edit/edit.component';

import * as _ from 'lodash';

import { BreadCrumbService } from '../../../../shared/services/breadcrumb.service';
import { syncItems } from 'src/utils';

@Component({
  selector: 'app-fastlc-action-statuses',
  templateUrl: './action-statuses.component.html',
})
export class FastlcActionStatusesListComponent implements OnInit {
  @ViewChild(GridComponent, { static: true })
  actionStatusesGrid?: GridComponent;

  // Available items
  items: any[] = [];
  selectedNodes: any[] = [];
  parentFiltered?: any;
  boolReference?: { value: boolean; name: string }[];
  // UI flag
  isLoading = false;
  // Local grid options
  gridOptions?: GridOptions;
  // Modal ref pointer
  bsModalRef?: BsModalRef;

  constructor(
    private translate: TranslateService,
    private data: DataService,
    private bsModalService: BsModalService,
    private toastr: ToasterService,
    public auth: AuthService,
    public router: Router,
    public breadCrumbService: BreadCrumbService
  ) {}

  /**
   */
  async ngOnInit(): Promise<void> {
    this.breadCrumbService.set(
      [
        {
          name: this.translate.instant('navigations.breadcrumbs.modules'),
          link: '/modules',
        },
        {
          name: this.translate.instant('navigations.breadcrumbs.parameters'),
          link: '/admin',
        },
        {
          name: this.translate.instant(
            'navigations.breadcrumbs.action_statuses'
          ),
          link: '/admin/fastlc/action-statuses',
        },
      ],
      2
    );
    this.gridOptions = {
      getRowId: (row: any) => row.data.id,
      suppressRowClickSelection: true,
      rowSelection: 'multiple',
      rowHeight: 30,
      headerHeight: 30,
      animateRows: true,
      floatingFiltersHeight: 30,
      enableCellTextSelection: false,
      suppressContextMenu: true,
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true,
        floatingFilter: true,
      },
      columnDefs: [
        {
          headerName: this.translate.instant(
            'headers.lifecycle_parameters.action_statuses.description'
          ),
          field: 'description',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: this.translate.instant(
            'headers.lifecycle_parameters.action_statuses.syst_status'
          ),
          field: 'systStatus',
          cellRenderer: (params: any): string => {
            if (params.value === 'completed') {
              return 'Completed';
            } else if (params.value === 'committed') {
              return 'Committed';
            } else if (params.value === 'created') {
              return 'Created';
            } else {
              return '';
            }
          },
        },
        {
          headerName: this.translate.instant(
            'headers.lifecycle_parameters.action_statuses.closed'
          ),
          field: 'closed',
          filter: 'agTextColumnFilter',
          cellRenderer: (params: any): string => {
            if (params.value === true) {
              return (
                '<span class="badge badge-lg badge-success">' +
                this.translate.instant('navigations.yes') +
                '</span>'
              );
            } else {
              return (
                '<span class="badge badge-lg badge-danger">' +
                this.translate.instant('navigations.no') +
                '</span>'
              );
            }
          },
        },
      ],
    };
    await this.loadItems();
  }

  /**
   */
  async loadItems(silent = false): Promise<void> {
    this.boolReference = [
      { value: true, name: this.translate.instant('navigations.yes') },
      { value: false, name: this.translate.instant('navigations.no') },
    ];

    if (!silent) {
      this.isLoading = true;
    }
    this.items = await this.data
      .by('api/fastlc/action-statuses', {
        criteria: {
          account: this.auth.getAccountId(),
        },
      })
      .toPromise();
    this.actionStatusesGrid?.gridApi?.sizeColumnsToFit();
    this.actionStatusesGrid?.uncheckAll();
    if (!silent) {
      this.isLoading = false;
    }
  }

  onFilterChanged(event: any): void {}

  onSelectionChanged(event: any): void {
    this.selectedNodes = event;
  }

  onRowClicked(event: any): void {
    this.showEditModal([new ActionStatusModel(event)]);
  }

  /**
   * @param items
   */
  async showEditModal(items?: ActionStatusModel[]): Promise<void> {
    this.bsModalRef = this.bsModalService.show(
      FastlcActionStatusesEditComponent,
      {
        initialState: {
          items,
          boolReference: this.boolReference,
        },
      }
    );
    this.bsModalRef.content.confirmFn = (res: ActionStatusModel) => {
      this.items = syncItems([res], this.items);
      this.toastr.showSuccess();
    };
  }

  showMassDeleteConfirm(): void {
    this.bsModalRef = this.bsModalService.show(ConfirmModalComponent, {
      initialState: {
        title: 'navigations.delete',
        content: '',
      },
    });
    this.bsModalRef.content.confirmFn = () => {
      this.isLoading = true;
      const ids = _.map(this.selectedNodes, (el) => el.id);
      this.data.post('api/fastlc/action-statuses/delete-all', ids).subscribe(
        (res) => {
          this.items = this.items.filter(
            (item: any) => !ids.includes(`${item.id}`)
          );
          this.toastr.showSuccess('messages.delete');
        },
        (err) => {
          this.toastr.showError();
        },
        () => {
          this.isLoading = false;
        }
      );
      this.bsModalRef?.hide();
    };
    this.bsModalRef.content.cancelFn = () => {
      this.bsModalRef?.hide();
    };
  }

  myCellCallback = (params: any) => {
    return params.value;
  };
}
